var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('b-container',{attrs:{"fluid":""}},[_c('Navbar'),_c('Home'),_c('Features'),_c('Images'),_c('Catalog'),_c('Delivery'),_c('Portfolio'),_c('Contact'),_c('Myfooter')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }